import {
  Combobox,
  ComboboxActionButton,
  ComboboxExtrasButton,
} from '@squareup/dex-ui';
import React, { FC, memo, useCallback } from 'react';

import { ApiExplorerFieldSpecialValuesDropdown } from '../helpers/ApiExplorerFieldSpecialValuesDropdown';
import { usePrimitiveProps } from '../hooks/nullable-hooks';
import { ApiExplorerPrimitiveFieldProps } from '../props';

const strings = {
  label: 'Generate',
};

interface Props extends ApiExplorerPrimitiveFieldProps {}

const ApiExplorerIdempotencyField: FC<Props> = memo(
  ({ currentValue, onChange, path, name, actionButton, isNullable }) => {
    const onInputChangeCallback = useCallback(
      (value: string) => {
        if (value === '') {
          onChange(undefined, path, 'remove');
        } else {
          onChange(value, path);
        }
      },
      [onChange, path]
    );

    const onGenerateButtonClicked = useCallback(() => {
      const idempotencyKey = crypto.randomUUID();
      onChange(idempotencyKey, path);
    }, [onChange, path]);

    const { placeholder, icon } = usePrimitiveProps(name, currentValue);

    return (
      <Combobox
        name={name}
        placeholder={placeholder}
        leadingAccessory={icon}
        value={currentValue?.toString()}
        onChange={onInputChangeCallback}
        actionButton={
          <>
            <ComboboxActionButton onClick={onGenerateButtonClicked}>
              {strings.label}
            </ComboboxActionButton>
            {actionButton}
          </>
        }
        extrasButton={
          <ApiExplorerFieldSpecialValuesDropdown
            currentValue={currentValue}
            showNullable={isNullable}
            showEmptyString={true}
            path={path}
            onChange={onChange}
            trigger={<ComboboxExtrasButton />}
          />
        }
      />
    );
  }
);

ApiExplorerIdempotencyField.displayName = 'ApiExplorerIdempotencyField';

export { ApiExplorerIdempotencyField };
